import * as React from 'react'

import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'

import CentsCustomField from './CentsCustomField'
import DateCustomField from './DateCustomField'
import LongTextCustomField from './LongTextCustomField'
import SingleChoiceCustomField from './SingleChoiceCustomField'
import TextCustomField from './TextCustomField'

interface Props {
  form: Form
  field: ResourceField
}

const CustomField = ({ form, field }: Props) => {
  switch (field.attributes.field_type) {
    case FieldTypes.text:
      return <TextCustomField form={form} field={field} />

    case FieldTypes.cents:
      return <CentsCustomField form={form} field={field} />

    case FieldTypes.date:
      return <DateCustomField form={form} field={field} />

    case FieldTypes.longText:
      return <LongTextCustomField form={form} field={field} />

    case FieldTypes.singleChoice:
      return <SingleChoiceCustomField form={form} field={field} />

    default:
      return null
  }
}

export default observer(CustomField)
